import React, { useContext, useState } from 'react'
import { AuthFetch } from '../../services/api'
import { notify, urlApiTMAN } from '../../utils/utils'
import { UserContext } from '../../context/provider/UserProvider'

export const useProductos = () => {
    const {stateUser} = useContext(UserContext)
    const COD_EMPRESA = stateUser.codEmpresa

    const [listaProductos,setListaProductos] = useState([])
    const [listaProductosYServicios,setListaProductosYServicios] = useState([])

    const listarProductos = async (codAlmacen) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Replacement/productDetailStore?' + new URLSearchParams({
                codEmpresa: COD_EMPRESA,
                codAlmacen: codAlmacen
            })
        })
        
        if(response.isValid){
            setListaProductos(response.content)
        }else{
            setListaProductos([])
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarProductosYServicios = async (codAlmacen) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Replacement/productDiagnosisWorkshop?' + new URLSearchParams({
                codEmpresa: COD_EMPRESA,
                codAlmacen: codAlmacen
            })
        })
        
        if(response.isValid){
            setListaProductosYServicios(response.content)
        }else{
            setListaProductosYServicios([])
            notify(response.exceptions[0].description,'error')
        }
    }
    return {
        listarProductos,
        listaProductos,
        setListaProductos,

        listarProductosYServicios,
        listaProductosYServicios,
        setListaProductosYServicios
    }
}
